import { create } from 'zustand';
import { TaskItem, TaskStatus } from '../types/spec';

interface TaskState {
  tasks: TaskItem[];
  statusFilter: TaskStatus | 'all';
  searchFilter: string;
  categoryFilter: string | null;

  setTasks: (tasks: TaskItem[]) => void;
  setStatusFilter: (status: TaskStatus | 'all') => void;
  setSearchFilter: (query: string) => void;
  setCategoryFilter: (category: string | null) => void;
  updateTaskStatus: (taskId: string, newStatus: TaskStatus) => void;

  getMetrics: () => {
    total: number;
    completed: number;
    inProgress: number;
    blocked: number;
    open: number;
    cancelled: number;
    percentComplete: number;
  };
}

export const useTaskStore = create<TaskState>((set, get) => ({
  tasks: [],
  statusFilter: 'all',
  searchFilter: '',
  categoryFilter: null,

  setTasks: (tasks) => set({ tasks }),
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setSearchFilter: (searchFilter) => set({ searchFilter }),
  setCategoryFilter: (categoryFilter) => set({ categoryFilter }),

  updateTaskStatus: (taskId, newStatus) => {
    set((state) => ({
      tasks: state.tasks.map((t) =>
        t.id === taskId ? { ...t, status: newStatus } : t
      )
    }));
  },

  getMetrics: () => {
    const tasks = get().tasks;
    const total = tasks.length;
    if (total === 0) {
      return { total: 0, completed: 0, inProgress: 0, blocked: 0, open: 0, cancelled: 0, percentComplete: 0 };
    }

    const completed = tasks.filter((t) => t.status === 'completed').length;
    const inProgress = tasks.filter((t) => t.status === 'in-progress').length;
    const blocked = tasks.filter((t) => t.status === 'blocked').length;
    const open = tasks.filter((t) => t.status === 'open').length;
    const cancelled = tasks.filter((t) => t.status === 'cancelled').length;

    const activeTotal = total - cancelled;
    const percentComplete = activeTotal > 0 ? Math.round((completed / activeTotal) * 100) : 0;

    return { total, completed, inProgress, blocked, open, cancelled, percentComplete };
  }
}));
